import { useContext } from 'react';

import { SettingsContext } from '../contexts';

export const useSettings = () => {
  return useContext(SettingsContext);
};
